/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 */


import { useStore } from '@/store'

import HttpClient, { HttpClientConfig } from 'axios-mapper'
import networkConfig from '@/config/default/net.config'

let traceCounter = 0
const generateTraceId = (): string => {
  const timePart = Date.now().toString(36)
  const randomPart = Math.random().toString(36).slice(2, 10)
  const counterPart = (traceCounter++ % 1e6).toString(36)
  return `${timePart}-${randomPart}-${counterPart}`
}

const https = (hasToken: Boolean = true, token?: string) => {
  const config: HttpClientConfig = {
    baseURL: networkConfig.host,
    headers: {
      Authorization: hasToken ? useStore().state.user.token : '',
      token,
      'X-Tgr-TraceId': generateTraceId()
    }
  }
  return new HttpClient(config)
}

export default https
